import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../context/shopContext';
import PersonalisationCartModal from '../personalisationCartModal/personalisationCartModal';
import './cartItems.css';
import trash_icon from '../assets/trash.svg';
import pencil from '../assets/pencil-solid.svg';
import PayButton from '../payButton/payButton';

const CartItems = () => {
    const { allProducts, cartItems, removeFromCart, getCartTotal, itemsInCart } = useContext(ShopContext);
    const [personalisationCartModal, setPersonalisationCartModal] = useState(false);
    const [currentItemIndex, setCurrentItemIndex] = useState(null);
    const [deliveryDate, setDeliveryDate] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
        calculateDeliveryDate();
    }, []);

    const cartItemsArray = Object.values(cartItems);

    const list_items = cartItemsArray.map(({ itemId, personalisation }) => {
        const item = allProducts.find(product => product.id === itemId);
        return item ? { ...item, personalisation } : null;
    }).filter(item => item !== null);

    const openPersonalisationCartModal = (index) => {
        setCurrentItemIndex(index);
        setPersonalisationCartModal(true);
    };

    const calculateDeliveryDate = () => {
        const now = new Date();
        const hour = now.getHours();
        const day = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

        let productionDate = new Date(now);
        if (hour >= 16 || day === 0 || day === 6) {
            do {
                productionDate.setDate(productionDate.getDate() + 1);
            } while (productionDate.getDay() === 0 || productionDate.getDay() === 6);
        }

        const deliveryDays = 2;
        let deliveryDate = new Date(productionDate);
        for (let i = 0; i < deliveryDays; i++) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
            while (deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
            }
        }

        const formattedDate = deliveryDate.toLocaleDateString('en-GB', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
        });
        setDeliveryDate(formattedDate);
    };

    return (
        <div className='cart-items'>
            <div className='cart-card-container'>
                <div>
                    {cartItemsArray.map(({ itemId, personalisation }, index) => {
                        const item = allProducts.find(product => product.id === itemId);
                        if (!item) return null;

                        return (
                            <div key={index}>
                                <div className="cart-card">
                                    <div>
                                        <Link to={`/card/${item.id}`}>
                                            <img className='cart-card-image' src={item.image} alt={item.name} />
                                        </Link>
                                    </div>

                                    <div className='item-cart-card-details'>
                                        <div className='cart-details-top'>
                                            <div>
                                                <p className='cart-product-title'>{item.name}</p>
                                                <p>£{item.price}</p>
                                            </div>
                                            <div>
                                                <img
                                                    className='cart-card-trash-icon'
                                                    src={trash_icon}
                                                    onClick={() => removeFromCart({ itemId, index })}
                                                    alt="Remove"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <button onClick={() => openPersonalisationCartModal(index)} className='cart-card-button'>
                                                {personalisation ? `Edit Message ` : `Add Message`}
                                                {personalisation && <img className='edit-icon' src={pencil} alt="Edit" />}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="cart-items-total">
                <div className="cart-items-total-box">
                    <div className='cart-items-total-delivery'>
                        <div className='order-by'>
                            <p>Order now and get it by {deliveryDate}*</p>
                        </div>
                    </div>

                    <div className='delivery'>
                        <p>Delivery</p>
                        <p>
                            <span>We offer Royal Mail 2nd Class post at £1.70 and First Class at £2.20. Cards are dispatched Mon-Fri within 24 hours of order when ordered before 4pm.</span>
                        </p>
                    </div>

                    <div className='cart-items-subtotal'>
                        <div>
                            <p>Subtotal</p>
                            <p><span>P&P not included</span></p>
                        </div>
                        <p>£{getCartTotal()}</p>
                    </div>

                    <div className='checkout-button'>
                        {itemsInCart() > 0 && <PayButton cartItems={cartItems} list_items={list_items} />}
                    </div>
                </div>
            </div>

            {personalisationCartModal && (
                <PersonalisationCartModal
                    closePersonalisationCartModal={setPersonalisationCartModal}
                    index={currentItemIndex}
                    id={cartItemsArray[currentItemIndex]?.itemId}
                    existingPersonalisation={cartItemsArray[currentItemIndex]?.personalisation}
                />
            )}
        </div>
    );
};

export default CartItems;
